import { Component } from 'react';
import * as Sentry from '@sentry/react';

const PALETTE = {
  cream: '#FFFDF8',
  bark: '#3D2B1F',
  gold: '#C9A96E',
  goldL: '#E8D5B0',
  stone: '#8B7D6B',
};

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Forward to Sentry; no-op when VITE_SENTRY_DSN isn't set (local dev,
    // or env not yet configured in Vercel).
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo?.componentStack } },
    });
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleRefresh = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: PALETTE.cream,
          fontFamily: "'Figtree', system-ui, -apple-system, sans-serif",
          padding: 24,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            maxWidth: 460,
            width: '100%',
            textAlign: 'center',
            padding: '36px 28px',
            background: '#fff',
            border: `1px solid ${PALETTE.goldL}`,
            borderRadius: 10,
            boxShadow: '0 2px 12px rgba(61, 43, 31, 0.06)',
          }}
        >
          <h1
            style={{
              color: PALETTE.bark,
              fontSize: 22,
              margin: '0 0 6px',
              fontWeight: 600,
              letterSpacing: '-0.01em',
            }}
          >
            Something went wrong
          </h1>
          <div
            style={{
              height: 1,
              background: PALETTE.gold,
              opacity: 0.4,
              margin: '20px auto',
              width: 80,
            }}
          />
          <p style={{ color: PALETTE.stone, fontSize: 14, margin: '0 0 24px', lineHeight: 1.5 }}>
            Please refresh the page to try again.
          </p>
          <button
            type="button"
            onClick={this.handleRefresh}
            style={{
              background: PALETTE.bark,
              color: PALETTE.cream,
              border: 'none',
              borderRadius: 6,
              padding: '10px 28px',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }
}
